import {
  API_STATES
} from '@/helpers'

const state = {
  billingGetState                  : API_STATES.NOT_REQUESTED,
  billingsGetError                 : null,
  billingSuccessMessage            : "",
  creditCardSuccessState           : API_STATES.NOT_REQUESTED,
  creditCardErrorState             : null,
  billingInvoiceSuccessState       : API_STATES.NOT_REQUESTED,
  billingInvoiceErrorState         : null,
  postBillingInvoiceSuccessMessage : "",
  packageSuccessState              : API_STATES.NOT_REQUESTED,
  packageErrorState                : null,
  invoicedata                      : [],
  billingCount                     : 0,
  billingSuccessCountGetState      : API_STATES.NOT_REQUESTED,
  billingCountGetErrorState        : null,
  billingDays                      : 0, 
  packageCancellationState         : API_STATES.NOT_REQUESTED,
  packageCancellationError         : null,
  packageReactivateState           : API_STATES.NOT_REQUESTED,
  packageReactivateError           : null,
  showPopup                        : false,
  packageType                      : 'Premium',
  packageRemoveState               : API_STATES.NOT_REQUESTED,
  packageRemoveError               : null,
}

export default state